import React from 'react';
import { ArrowRight, Check, ShieldCheck, Download, Star, Lock, CreditCard } from 'lucide-react';
import { CountdownTimer } from '../components/CountdownTimer';
import { PurchasePopup } from '../components/PurchasePopup';
export function LandingPage() {
  const scrollToPurchase = () => {
    const element = document.getElementById('purchase-section');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="min-h-screen bg-white font-sans text-gray-900 pb-20" data-id="element-18">
      <CountdownTimer data-id="element-19" />
      <PurchasePopup data-id="element-20" />

      {/* HERO SECTION */}
      <header className="bg-black text-white py-6 px-4 text-center border-b-8 border-yellow-400" data-id="element-21">
        <div className="max-w-4xl mx-auto" data-id="element-22">
          <p className="text-green-400 font-bold tracking-widest uppercase mb-3 text-sm animate-pulse" data-id="element-23">
            PARA DOCENTES DE CONTABILIDAD EN SECUNDARIA
          </p>

          <h1 className="text-2xl md:text-4xl lg:text-5xl font-black mb-4 leading-tight" data-id="element-24">
            Resolvé todo tu año de Contabilidad y arrancá las clases con todo
            listo con el{' '}
            <span className="text-yellow-400 underline decoration-4 underline-offset-4" data-id="element-25">
              MEGA PACK CONTABILIDAD LISTA
            </span>
          </h1>

          {/* Main Product Image */}
          <div className="mb-4 cursor-pointer" onClick={scrollToPurchase} data-id="element-26">
            <img src="https://cdn.magicpatterns.com/uploads/81MdeTeSXShGXnmLpVb86i/CONJUNTO_DE_MOCKUPS_contabilidad_(1).png" alt="Mega Pack Contabilidad Lista" className="w-full max-w-2xl mx-auto drop-shadow-2xl" data-id="element-27" />
          </div>

          <p className="text-base md:text-lg text-gray-300 mb-5 max-w-3xl mx-auto" data-id="element-28">
            Sistema integral de clases, secuencias, actividades, proyectos y
            recursos organizados por unidades de Contabilidad.
          </p>

          <button onClick={scrollToPurchase} className="bg-green-600 hover:bg-green-500 text-white text-base md:text-xl font-black py-4 px-6 rounded-lg shadow-[0_6px_0_rgb(21,128,61)] hover:shadow-[0_4px_0_rgb(21,128,61)] hover:translate-y-[2px] transition-all mx-auto flex items-center justify-center gap-2 uppercase tracking-wide" data-id="element-29">
            <span data-id="element-30">👉 SÍ, QUIERO ACCESO INMEDIATO</span>
          </button>

          <div className="flex flex-wrap justify-center gap-3 mt-4 text-xs md:text-sm text-gray-400 font-medium" data-id="element-31">
            <span className="flex items-center gap-1" data-id="element-32">
              <Lock className="w-3 h-3" data-id="element-33" /> Pago seguro
            </span>
            <span className="flex items-center gap-1" data-id="element-34">
              <Download className="w-3 h-3" data-id="element-35" /> Descarga inmediata
            </span>
            <span className="flex items-center gap-1" data-id="element-36">
              <ShieldCheck className="w-3 h-3" data-id="element-37" /> Garantía 7 días
            </span>
            <span className="flex items-center gap-1" data-id="element-38">
              <Star className="w-3 h-3" data-id="element-39" /> Acceso de por vida
            </span>
          </div>
        </div>
      </header>

      {/* PAIN POINTS SECTION */}
      <section className="py-8 px-4 bg-white" data-id="element-40">
        <div className="max-w-3xl mx-auto" data-id="element-41">
          <h2 className="text-2xl md:text-3xl font-black text-center mb-6 text-gray-900 uppercase" data-id="element-42">
            SI SOS DOCENTE DE CONTABILIDAD,{' '}
            <span className="bg-yellow-200 px-2" data-id="element-43">
              ESTO TE VA A SONAR FAMILIAR…
            </span>
          </h2>

          <div className="space-y-3 text-base md:text-lg text-gray-700" data-id="element-44">
            <div className="flex items-start gap-3 p-3 bg-red-50 rounded-lg border-l-4 border-red-500" data-id="element-45">
              <span className="text-2xl" data-id="element-46">📚</span>
              <p data-id="element-47">
                <strong data-id="element-48">Armás clases desde cero</strong> una y otra vez,
                perdiendo horas valiosas de tu tiempo personal.
              </p>
            </div>
            <div className="flex items-start gap-3 p-3 bg-red-50 rounded-lg border-l-4 border-red-500" data-id="element-49">
              <span className="text-2xl" data-id="element-50">🧠</span>
              <p data-id="element-51">
                Terminás una clase y{' '}
                <strong data-id="element-52">ya estás pensando en la siguiente</strong>, sin descanso
                mental real.
              </p>
            </div>
            <div className="flex items-start gap-3 p-3 bg-red-50 rounded-lg border-l-4 border-red-500" data-id="element-53">
              <span className="text-2xl" data-id="element-54">😓</span>
              <p data-id="element-55">
                Trabajás mucho, pero sentís que <strong data-id="element-56">nunca alcanza</strong> y
                el material se agota rápido.
              </p>
            </div>
            <div className="flex items-start gap-3 p-3 bg-red-50 rounded-lg border-l-4 border-red-500" data-id="element-57">
              <span className="text-2xl" data-id="element-58">🏫</span>
              <p data-id="element-59">
                Entrás al aula <strong data-id="element-60">cansado/a antes de empezar</strong> por
                el estrés de la planificación.
              </p>
            </div>
          </div>

          <div className="mt-6 text-center" data-id="element-61">
            <p className="text-xl font-bold text-red-600 mb-2" data-id="element-62">
              ❌ No es falta de vocación. ❌ No es falta de ganas.
            </p>
            <p className="text-2xl font-black text-gray-900 bg-yellow-100 inline-block px-4 py-2 transform -rotate-1" data-id="element-63">
              👉 Es falta de un sistema claro y material listo.
            </p>
            <p className="mt-4 text-lg text-gray-600" data-id="element-64">
              🔁 Sin un sistema, repetís el mismo desgaste todas las semanas.
            </p>
          </div>
        </div>
      </section>

      {/* SOLUTION SECTION */}
      <section className="py-8 px-4 bg-gray-50 border-y border-gray-200" data-id="element-65">
        <div className="max-w-4xl mx-auto text-center" data-id="element-66">
          <h2 className="text-2xl md:text-3xl font-black mb-4 text-blue-900" data-id="element-67">
            Por eso creamos el{' '}
            <span className="text-blue-600" data-id="element-68">
              KIT COMPLETO CONTABILIDAD LISTA
            </span>
          </h2>
          <p className="text-base text-gray-700 mb-6 max-w-2xl mx-auto" data-id="element-69">
            Un sistema pensado para dejar de improvisar y entrar al aula con
            todo resuelto.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-left" data-id="element-70">
            <div className="bg-white p-4 rounded-xl shadow-md border border-gray-100" data-id="element-71">
              <h3 className="text-lg font-bold text-blue-800 mb-1 flex items-center gap-2" data-id="element-72">
                <span className="text-xl" data-id="element-73">📘</span> Todos los años organizados
              </h3>
              <p className="text-gray-600 text-sm" data-id="element-74">
                4 cuadernillos listos para secundaria, estructurados
                pedagógicamente.
              </p>
            </div>
            <div className="bg-white p-4 rounded-xl shadow-md border border-gray-100" data-id="element-75">
              <h3 className="text-lg font-bold text-blue-800 mb-1 flex items-center gap-2" data-id="element-76">
                <span className="text-xl" data-id="element-77">🧩</span> Clases listas para aplicar
              </h3>
              <p className="text-gray-600 text-sm" data-id="element-78">
                Actividades que funcionan, probadas en el aula, sin empezar de
                cero.
              </p>
            </div>
            <div className="bg-white p-4 rounded-xl shadow-md border border-gray-100" data-id="element-79">
              <h3 className="text-lg font-bold text-blue-800 mb-1 flex items-center gap-2" data-id="element-80">
                <span className="text-xl" data-id="element-81">📊</span> Contenidos claros y
                prácticos
              </h3>
              <p className="text-gray-600 text-sm" data-id="element-82">
                Teoría explicada paso a paso, ejemplos reales y recursos
                visuales.
              </p>
            </div>
            <div className="bg-white p-4 rounded-xl shadow-md border border-gray-100" data-id="element-83">
              <h3 className="text-lg font-bold text-blue-800 mb-1 flex items-center gap-2" data-id="element-84">
                <span className="text-xl" data-id="element-85">⏱️</span> Más tiempo y tranquilidad
              </h3>
              <p className="text-gray-600 text-sm" data-id="element-86">
                Menos planificación. Más seguridad al enseñar. Recuperá tus
                fines de semana.
              </p>
            </div>
          </div>

          <div className="mt-6" data-id="element-87">
            <p className="text-xl font-bold text-green-700 mb-4" data-id="element-88">
              ✨ Menos estrés. Más orden. Más disfrute al dar clase.
            </p>
            <button onClick={scrollToPurchase} className="bg-green-600 hover:bg-green-500 text-white text-lg font-bold py-3 px-8 rounded-lg shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 w-full max-w-md" data-id="element-89">
              QUIERO VER EL MATERIAL 👉
            </button>
          </div>
        </div>
      </section>

      {/* WHAT'S INCLUDED SECTION */}
      <section className="py-8 px-4 bg-white" data-id="element-90">
        <div className="max-w-5xl mx-auto" data-id="element-91">
          <h2 className="text-2xl md:text-4xl font-black text-center mb-8 text-gray-900 uppercase tracking-tight" data-id="element-92">
            📦 ¿QUÉ INCLUYE EL KIT COMPLETO?
          </h2>

          <div className="space-y-6" data-id="element-93">
            {/* Module 1 */}
            <div className="border-b border-gray-100 pb-6" data-id="element-94">
              <h3 className="text-xl font-black text-blue-900 mb-3 bg-blue-50 inline-block px-4 py-1 rounded-r-full border-l-4 border-blue-600" data-id="element-95">
                📘 Cuadernillo 1 – Fundamentos de la Contabilidad
              </h3>
              <ul className="space-y-2 text-gray-700 text-sm md:text-base" data-id="element-96">
                {['Concepto y objetivos de la contabilidad', 'Importancia en la vida cotidiana y las organizaciones', 'Usuarios de la información contable', 'Tipos de contabilidad', 'Patrimonio: Activo, Pasivo y Patrimonio Neto', 'Ecuación y variaciones patrimoniales', 'La empresa y su clasificación', 'Introducción al lenguaje contable y hechos económicos'].map((item, i) => <li key={i} className="flex items-start gap-2" data-id="element-97">
                    <Check className="w-4 h-4 text-green-500 flex-shrink-0 mt-1" data-id="element-98" />
                    <span data-id="element-99">{item}</span>
                  </li>)}
              </ul>
            </div>

            {/* Module 2 */}
            <div className="border-b border-gray-100 pb-6" data-id="element-100">
              <h3 className="text-xl font-black text-green-900 mb-3 bg-green-50 inline-block px-4 py-1 rounded-r-full border-l-4 border-green-600" data-id="element-101">
                📗 Cuadernillo 2 – Documentación y Registración Contable
              </h3>
              <ul className="space-y-2 text-gray-700 text-sm md:text-base" data-id="element-102">
                {['Documentación comercial y su función', 'Facturas, recibos, remitos', 'Notas de débito y crédito', 'Comprobantes electrónicos', 'Hechos económicos y su impacto patrimonial', 'Cuentas contables y plan de cuentas', 'Asientos contables', 'Libro Diario y Libro Mayor', 'Registración paso a paso con ejercicios integrales'].map((item, i) => <li key={i} className="flex items-start gap-2" data-id="element-103">
                    <Check className="w-4 h-4 text-green-500 flex-shrink-0 mt-1" data-id="element-104" />
                    <span data-id="element-105">{item}</span>
                  </li>)}
              </ul>
            </div>

            {/* Module 3 */}
            <div className="border-b border-gray-100 pb-6" data-id="element-106">
              <h3 className="text-xl font-black text-orange-900 mb-3 bg-orange-50 inline-block px-4 py-1 rounded-r-full border-l-4 border-orange-600" data-id="element-107">
                📙 Cuadernillo 3 – Resultados y Estados Contables
              </h3>
              <ul className="space-y-2 text-gray-700 text-sm md:text-base" data-id="element-108">
                {['Ingresos, costos y gastos', 'Resultado del ejercicio', 'Estado de Resultados', 'Armado e interpretación básica', 'Estado de Situación Patrimonial', 'Activo, Pasivo y Patrimonio Neto', 'Análisis simple de estados contables', 'Casos prácticos y ejercicios integradores'].map((item, i) => <li key={i} className="flex items-start gap-2" data-id="element-109">
                    <Check className="w-4 h-4 text-green-500 flex-shrink-0 mt-1" data-id="element-110" />
                    <span data-id="element-111">{item}</span>
                  </li>)}
              </ul>
            </div>

            {/* Module 4 */}
            <div data-id="element-112">
              <h3 className="text-xl font-black text-red-900 mb-3 bg-red-50 inline-block px-4 py-1 rounded-r-full border-l-4 border-red-600" data-id="element-113">
                📕 Cuadernillo 4 – Contabilidad Aplicada y Educación Financiera
              </h3>
              <ul className="space-y-2 text-gray-700 text-sm md:text-base" data-id="element-114">
                {['Contabilidad en la vida real', 'Emprendimientos y PYMES', 'Empresa escolar y simulaciones', 'Registro simplificado', 'Educación financiera', 'Presupuesto, ahorro y consumo responsable', 'Aplicación práctica para todos los años'].map((item, i) => <li key={i} className="flex items-start gap-2" data-id="element-115">
                    <Check className="w-4 h-4 text-green-500 flex-shrink-0 mt-1" data-id="element-116" />
                    <span data-id="element-117">{item}</span>
                  </li>)}
              </ul>
              <div className="mt-4 p-3 bg-yellow-50 border border-yellow-200 rounded-lg text-center font-bold text-yellow-800 text-sm" data-id="element-118">
                ✅ Ideal para ahorrar tiempo y enseñar con seguridad
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* TRANSFORMATION SECTION */}
      <section className="py-8 px-4 bg-gray-900 text-white" data-id="element-119">
        <div className="max-w-4xl mx-auto text-center" data-id="element-120">
          <h2 className="text-2xl md:text-4xl font-black mb-6 text-yellow-400 uppercase" data-id="element-121">
            RESULTADOS QUE TRANSFORMAN
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-122">
            <div className="bg-gray-800 p-5 rounded-xl border border-gray-700" data-id="element-123">
              <h3 className="text-xl font-bold mb-4 text-white border-b border-gray-600 pb-3" data-id="element-124">
                Para tus estudiantes
              </h3>
              <ul className="space-y-3 text-left text-gray-300 text-sm" data-id="element-125">
                <li className="flex items-start gap-2" data-id="element-126">
                  <CheckCircle2 className="w-5 h-5 text-green-400 flex-shrink-0" data-id="element-127" />
                  <span data-id="element-128">Comprenden la lógica contable con claridad</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-129">
                  <CheckCircle2 className="w-5 h-5 text-green-400 flex-shrink-0" data-id="element-130" />
                  <span data-id="element-131">Aplican conceptos a situaciones reales</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-132">
                  <CheckCircle2 className="w-5 h-5 text-green-400 flex-shrink-0" data-id="element-133" />
                  <span data-id="element-134">Interpretan estados contables</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-135">
                  <CheckCircle2 className="w-5 h-5 text-green-400 flex-shrink-0" data-id="element-136" />
                  <span data-id="element-137">Participan activamente en clase</span>
                </li>
              </ul>
            </div>
            <div className="bg-gray-800 p-5 rounded-xl border border-gray-700" data-id="element-138">
              <h3 className="text-xl font-bold mb-4 text-white border-b border-gray-600 pb-3" data-id="element-139">
                Para vos como docente
              </h3>
              <ul className="space-y-3 text-left text-gray-300 text-sm" data-id="element-140">
                <li className="flex items-start gap-2" data-id="element-141">
                  <CheckCircle2 className="w-5 h-5 text-green-400 flex-shrink-0" data-id="element-142" />
                  <span data-id="element-143">Ahorrás horas de planificación semanal</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-144">
                  <CheckCircle2 className="w-5 h-5 text-green-400 flex-shrink-0" data-id="element-145" />
                  <span data-id="element-146">Tenés seguridad conceptual total</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-147">
                  <CheckCircle2 className="w-5 h-5 text-green-400 flex-shrink-0" data-id="element-148" />
                  <span data-id="element-149">Todo organizado por unidades lógicas</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-150">
                  <CheckCircle2 className="w-5 h-5 text-green-400 flex-shrink-0" data-id="element-151" />
                  <span data-id="element-152">Recuperás tu tiempo personal y familiar</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* BONUSES SECTION */}
      <section className="py-8 px-4 bg-white" data-id="element-153">
        <div className="max-w-5xl mx-auto" data-id="element-154">
          <h2 className="text-2xl md:text-4xl font-black text-center mb-2 text-red-600 uppercase" data-id="element-155">
            🎁 BONOS EXCLUSIVOS INCLUIDOS HOY
          </h2>
          <p className="text-center text-base text-gray-600 mb-6 font-bold" data-id="element-156">
            (Solo disponibles por tiempo limitado)
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5" data-id="element-157">
            <div className="bg-white rounded-xl shadow-lg border-2 border-yellow-400 overflow-hidden flex flex-col" data-id="element-158">
              <div className="bg-yellow-400 text-black font-bold text-center py-2 uppercase tracking-wide text-sm" data-id="element-159">
                🎁 BONO 1 – GRATIS
              </div>
              <div className="p-4 flex-1 flex flex-col items-center text-center" data-id="element-160">
                <img src="https://cdn.magicpatterns.com/uploads/atazGoKaYsToFesgY2TgKm/bonus_planificacion_anual_.png" alt="Planificación Anual" className="w-40 h-40 object-contain mb-3" data-id="element-161" />
                <h3 className="text-lg font-bold text-gray-900 mb-1" data-id="element-162">
                  PLANIFICACIÓN ANUAL LISTA
                </h3>
                <p className="text-gray-600 text-xs" data-id="element-163">
                  Incluye planificaciones listas y estructuradas para todo el
                  ciclo lectivo.
                </p>
                <p className="mt-3 text-green-600 font-bold text-base" data-id="element-164">
                  Valor:{' '}
                  <span className="line-through text-red-500 text-xs" data-id="element-165">
                    $15.000
                  </span>{' '}
                  GRATIS
                </p>
              </div>
            </div>
            <div className="bg-white rounded-xl shadow-lg border-2 border-yellow-400 overflow-hidden flex flex-col" data-id="element-166">
              <div className="bg-yellow-400 text-black font-bold text-center py-2 uppercase tracking-wide text-sm" data-id="element-167">
                🎁 BONO 2 – GRATIS
              </div>
              <div className="p-4 flex-1 flex flex-col items-center text-center" data-id="element-168">
                <img src="https://cdn.magicpatterns.com/uploads/sbFstrgRxkTBRojssQTasV/bonus_maletin_de_actividades_.png" alt="Maletín de Actividades" className="w-40 h-40 object-contain mb-3" data-id="element-169" />
                <h3 className="text-lg font-bold text-gray-900 mb-1" data-id="element-170">
                  MALETÍN DE ACTIVIDADES
                </h3>
                <p className="text-gray-600 text-xs" data-id="element-171">
                  Actividades prácticas listas para aplicar en el aula
                  inmediatamente.
                </p>
                <p className="mt-3 text-green-600 font-bold text-base" data-id="element-172">
                  Valor:{' '}
                  <span className="line-through text-red-500 text-xs" data-id="element-173">
                    $12.000
                  </span>{' '}
                  GRATIS
                </p>
              </div>
            </div>
            <div className="bg-white rounded-xl shadow-lg border-2 border-yellow-400 overflow-hidden flex flex-col" data-id="element-174">
              <div className="bg-yellow-400 text-black font-bold text-center py-2 uppercase tracking-wide text-sm" data-id="element-175">
                🎁 BONO 3 – GRATIS
              </div>
              <div className="p-4 flex-1 flex flex-col items-center text-center" data-id="element-176">
                <img src="https://cdn.magicpatterns.com/uploads/2iywd7GooKjCfdAvduy1ea/bonus_primeros_auxilios.png" alt="Guía de Primeros Auxilios" className="w-40 h-40 object-contain mb-3" data-id="element-177" />
                <h3 className="text-lg font-bold text-gray-900 mb-1" data-id="element-178">
                  GUÍA DE PRIMEROS AUXILIOS
                </h3>
                <p className="text-gray-600 text-xs" data-id="element-179">
                  Explica de forma clara y práctica cómo actuar ante emergencias
                  escolares.
                </p>
                <p className="mt-3 text-green-600 font-bold text-base" data-id="element-180">
                  Valor:{' '}
                  <span className="line-through text-red-500 text-xs" data-id="element-181">
                    $8.000
                  </span>{' '}
                  GRATIS
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* OFFER SECTION (MAIN) */}
      <section id="purchase-section" className="py-8 px-4 bg-yellow-50 border-y-4 border-yellow-400" data-id="element-182">
        <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-2xl overflow-hidden border border-gray-200" data-id="element-183">
          <div className="bg-red-600 text-white text-center py-2 font-bold text-lg uppercase tracking-wider animate-pulse" data-id="element-184">
            🔥 OFERTA ESPECIAL POR TIEMPO LIMITADO
          </div>

          <div className="p-6 md:p-8 text-center" data-id="element-185">
            <h2 className="text-2xl md:text-4xl font-black text-gray-900 mb-3" data-id="element-186">
              MEGA PACK CONTABILIDAD LISTA
            </h2>

            <div className="flex flex-wrap justify-center gap-3 text-xs font-semibold text-gray-500 mb-5 uppercase tracking-wide" data-id="element-187">
              <span className="flex items-center gap-1" data-id="element-188">
                <Check className="w-3 h-3 text-green-500" data-id="element-189" /> Acceso de por vida
              </span>
              <span className="flex items-center gap-1" data-id="element-190">
                <Check className="w-3 h-3 text-green-500" data-id="element-191" /> Descarga inmediata
              </span>
              <span className="flex items-center gap-1" data-id="element-192">
                <Check className="w-3 h-3 text-green-500" data-id="element-193" /> Garantía 7 días
              </span>
              <span className="flex items-center gap-1" data-id="element-194">
                <Check className="w-3 h-3 text-green-500" data-id="element-195" /> 3 Bonos incluidos
              </span>
            </div>

            <div className="mb-5" data-id="element-196">
              <p className="text-gray-500 text-base mb-1" data-id="element-197">
                Precio regular{' '}
                <span className="line-through decoration-red-500 decoration-2" data-id="element-198">
                  $49.990 ARS
                </span>
              </p>
              <div className="flex items-center justify-center gap-3" data-id="element-199">
                <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm font-bold uppercase" data-id="element-200">
                  Hoy
                </span>
                <p className="text-4xl md:text-6xl font-black text-gray-900 tracking-tight" data-id="element-201">
                  $19.990{' '}
                  <span className="text-xl text-gray-500 font-normal" data-id="element-202">ARS</span>
                </p>
              </div>
            </div>

            <a href="https://mi-tienda-2-8952.myshopify.com/cart/51554510143808:1" className="block w-full bg-green-600 hover:bg-green-500 text-white text-lg md:text-2xl font-black py-5 px-8 rounded-lg shadow-[0_6px_0_rgb(21,128,61)] hover:shadow-[0_4px_0_rgb(21,128,61)] hover:translate-y-[2px] transition-all mb-4 uppercase tracking-wide" data-id="element-203">
              👉 SÍ, QUIERO EL MEGA PACK
            </a>

            <div className="flex flex-col items-center gap-2" data-id="element-204">
              <p className="text-xs text-gray-500 font-medium" data-id="element-205">
                Métodos de pago seguros:
              </p>
              <div className="flex gap-3 text-gray-400 items-center" data-id="element-206">
                <CreditCard className="w-6 h-6" data-id="element-207" />
                <span className="font-bold text-gray-600 text-sm" data-id="element-208">
                  Mercado Pago
                </span>
                <span className="font-bold text-gray-600 text-sm" data-id="element-209">Visa</span>
                <span className="font-bold text-gray-600 text-sm" data-id="element-210">
                  Mastercard
                </span>
              </div>
              <p className="text-xs text-gray-400" data-id="element-211">
                Transferencia disponible por WhatsApp
              </p>
            </div>
          </div>

          <div className="bg-gray-50 p-4 border-t border-gray-100 text-center text-xs text-gray-600" data-id="element-212">
            <p className="font-bold mb-1" data-id="element-213">🔽 ¿Cómo recibís el material?</p>
            <p data-id="element-214">
              Paso 1: Realizás la compra. Paso 2: Finalizás el pago. Paso 3:
              Recibís el link automáticamente en tu correo.
            </p>
            <p className="mt-1 text-red-500 font-bold" data-id="element-215">
              IMPORTANTE: Revisar carpeta de spam.
            </p>
          </div>
        </div>
      </section>

      {/* UPSELL 1 - MOST POPULAR */}
      <section className="py-8 px-4 bg-white" data-id="element-216">
        <div className="max-w-4xl mx-auto border-4 border-blue-500 rounded-2xl overflow-hidden shadow-xl relative" data-id="element-217">
          <div className="absolute top-0 right-0 bg-blue-500 text-white px-4 py-1 font-bold rounded-bl-xl uppercase text-xs" data-id="element-218">
            ⭐ MÁS POPULAR
          </div>

          <div className="p-6 md:p-8 flex flex-col items-center text-center gap-5" data-id="element-219">
            <h3 className="text-xl md:text-2xl font-black text-gray-900 leading-tight text-center" data-id="element-220">
              KIT COMPLETO CONTABILIDAD LISTA +{' '}
              <span className="text-blue-600" data-id="element-221">
                ORGANIZACIONES, GESTIÓN Y PROYECTOS
              </span>
            </h3>

            <img src="https://cdn.magicpatterns.com/uploads/kuRGDJ4pZ2vSYrGSX3XfNp/20260120_2359_OrganizacionyGestionEducativa_remix_01kff7s0sven19f428ghpprs8k.png" alt="Pack Organizaciones" className="w-full max-w-lg h-auto object-contain" data-id="element-222" />

            <div className="w-full max-w-xl" data-id="element-223">
              <div className="bg-blue-50 p-3 rounded-lg border border-blue-100 mb-4" data-id="element-224">
                <p className="font-bold text-blue-900 mb-1 text-center text-sm" data-id="element-225">
                  ¿Qué incluye el SISTEMA PRO DE ORGANIZACIONES?
                </p>
                <ul className="space-y-1 text-xs text-blue-800 text-center" data-id="element-226">
                  <li data-id="element-227">📊 Teoría de las Organizaciones</li>
                  <li data-id="element-228">🏢 Gestión Organizacional</li>
                  <li data-id="element-229">📝 Proyecto Organizacional aplicado</li>
                </ul>
              </div>

              <div className="mb-4 text-center" data-id="element-230">
                <p className="text-gray-500 text-xs line-through" data-id="element-231">
                  Precio regular $34.990 ARS
                </p>
                <p className="text-3xl font-black text-gray-900" data-id="element-232">
                  $24.990 <span className="text-base text-gray-500" data-id="element-233">ARS</span>
                </p>
                <p className="text-green-600 font-bold text-xs bg-green-100 inline-block px-2 rounded" data-id="element-234">
                  Ahorrás $10.000 ARS
                </p>
              </div>

              <a href="https://mi-tienda-2-8952.myshopify.com/cart/51554508833088:1" className="block w-full bg-green-600 hover:bg-green-500 text-white text-base font-black py-3 px-6 rounded-lg shadow-md hover:shadow-lg transition-all text-center uppercase" data-id="element-235">
                👉 SÍ, QUIERO EL PACK DOBLE
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* UPSELL 2 - EXCLUSIVE OFFER */}
      <section className="py-8 px-4 bg-gray-900 text-white" data-id="element-236">
        <div className="max-w-4xl mx-auto border-4 border-yellow-400 rounded-2xl overflow-hidden shadow-[0_0_30px_rgba(251,191,36,0.3)] relative bg-gray-800" data-id="element-237">
          <div className="bg-yellow-400 text-black text-center py-2 font-black text-lg uppercase tracking-wider" data-id="element-238">
            ⭐ OFERTA EXCLUSIVA - SUPER PACK COMPLETO
          </div>

          <div className="p-6 md:p-8 text-center" data-id="element-239">
            <h3 className="text-xl md:text-3xl font-black text-white mb-4 leading-tight" data-id="element-240">
              KIT CONTABILIDAD + ORGANIZACIONES +{' '}
              <span className="text-yellow-400" data-id="element-241">KIT ECONOMÍA LISTA</span>
            </h3>

            <a href="https://mi-tienda-2-8952.myshopify.com/cart/51554510471488:1" data-id="element-242">
              <img src="https://cdn.magicpatterns.com/uploads/9ZCNAjZzXJfKVumTQ65W49/20260115_0125_ImageGeneration_remix_01kezyb6ypfd58n2qqzct59y6w.png" alt="Todo Economía y Contabilidad" className="w-full max-w-2xl mx-auto h-auto object-contain mb-5 rounded-xl hover:scale-105 transition duration-300" data-id="element-243" />
            </a>

            <p className="text-gray-300 text-base mb-5 max-w-2xl mx-auto" data-id="element-244">
              Incluye todo el contenido de Economía y Contabilidad organizado de
              2° a 6° año, con cuadernillos, planificaciones anuales y
              secuencias didácticas listas para usar.
            </p>

            <div className="mb-5 bg-gray-900 inline-block p-4 rounded-xl border border-gray-700" data-id="element-245">
              <p className="text-gray-400 text-xs line-through mb-1" data-id="element-246">
                Precio regular $44.990 ARS
              </p>
              <p className="text-4xl font-black text-white mb-1" data-id="element-247">
                $34.990 <span className="text-xl text-gray-500" data-id="element-248">ARS</span>
              </p>
              <p className="text-yellow-400 font-bold text-xs uppercase tracking-wide" data-id="element-249">
                🔥 Ahorrás $10.000 ARS
              </p>
            </div>

            <a href="https://mi-tienda-2-8952.myshopify.com/cart/51554510471488:1" className="block w-full max-w-xl mx-auto bg-green-600 hover:bg-green-500 text-white text-lg md:text-xl font-black py-4 px-8 rounded-lg shadow-[0_6px_0_rgb(21,128,61)] hover:shadow-[0_4px_0_rgb(21,128,61)] hover:translate-y-[2px] transition-all uppercase" data-id="element-250">
              👉 SÍ, QUIERO EL SUPER PACK COMPLETO
            </a>
          </div>
        </div>
      </section>

      {/* GUARANTEE SECTION */}
      <section className="py-8 px-4 bg-white" data-id="element-251">
        <div className="max-w-3xl mx-auto flex flex-col md:flex-row items-center gap-5 border-4 border-gray-100 p-6 rounded-2xl" data-id="element-252">
          <div className="flex-shrink-0" data-id="element-253">
            <ShieldCheck className="w-20 h-20 text-green-600" data-id="element-254" />
          </div>
          <div data-id="element-255">
            <h2 className="text-2xl font-black text-gray-900 mb-2 uppercase" data-id="element-256">
              GARANTÍA TOTAL DE 7 DÍAS
            </h2>
            <p className="text-base text-gray-700 mb-2" data-id="element-257">
              Probalo por 7 días. Si el material no cumple tus expectativas o no
              es lo que buscabas, te devolvemos el 100% de tu dinero.
            </p>
            <p className="font-bold text-gray-900 text-sm" data-id="element-258">
              Sin preguntas. Sin letra chica.
            </p>
          </div>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="py-8 px-4 bg-gray-50" data-id="element-259">
        <div className="max-w-6xl mx-auto" data-id="element-260">
          <h2 className="text-2xl md:text-3xl font-black text-center mb-6 text-gray-900 uppercase" data-id="element-261">
            TESTIMONIOS DE DOCENTES
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5" data-id="element-262">
            <div className="bg-white p-5 rounded-xl shadow-md border-t-4 border-green-500" data-id="element-263">
              <div className="flex items-center gap-1 text-yellow-400 mb-3" data-id="element-264">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-265" />)}
              </div>
              <p className="text-gray-700 italic mb-4 text-sm" data-id="element-266">
                "Ahora tengo la Contabilidad organizada por unidades, no
                improviso más. El material es excelente y muy completo."
              </p>
              <div className="flex items-center gap-2" data-id="element-267">
                <div className="w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center font-bold text-gray-500 text-xs" data-id="element-268">
                  ML
                </div>
                <div data-id="element-269">
                  <p className="font-bold text-gray-900 text-sm" data-id="element-270">María L.</p>
                  <p className="text-xs text-gray-500" data-id="element-271">Córdoba</p>
                </div>
              </div>
            </div>
            <div className="bg-white p-5 rounded-xl shadow-md border-t-4 border-green-500" data-id="element-272">
              <div className="flex items-center gap-1 text-yellow-400 mb-3" data-id="element-273">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-274" />)}
              </div>
              <p className="text-gray-700 italic mb-4 text-sm" data-id="element-275">
                "Los ejercicios prácticos mejoraron muchísimo la comprensión de
                mis alumnos. Es justo lo que necesitaba."
              </p>
              <div className="flex items-center gap-2" data-id="element-276">
                <div className="w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center font-bold text-gray-500 text-xs" data-id="element-277">
                  FR
                </div>
                <div data-id="element-278">
                  <p className="font-bold text-gray-900 text-sm" data-id="element-279">Fernando R.</p>
                  <p className="text-xs text-gray-500" data-id="element-280">Buenos Aires</p>
                </div>
              </div>
            </div>
            <div className="bg-white p-5 rounded-xl shadow-md border-t-4 border-green-500" data-id="element-281">
              <div className="flex items-center gap-1 text-yellow-400 mb-3" data-id="element-282">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-283" />)}
              </div>
              <p className="text-gray-700 italic mb-4 text-sm" data-id="element-284">
                "El sistema es claro, ordenado y profesional. Me ahorró semanas
                de trabajo en planificación."
              </p>
              <div className="flex items-center gap-2" data-id="element-285">
                <div className="w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center font-bold text-gray-500 text-xs" data-id="element-286">
                  CP
                </div>
                <div data-id="element-287">
                  <p className="font-bold text-gray-900 text-sm" data-id="element-288">Carla P.</p>
                  <p className="text-xs text-gray-500" data-id="element-289">Mendoza</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FINAL CTA */}
      <section className="py-10 px-4 bg-gray-900 text-white text-center" data-id="element-290">
        <div className="max-w-3xl mx-auto" data-id="element-291">
          <h2 className="text-2xl md:text-4xl font-black mb-4 uppercase text-white" data-id="element-292">
            ¿LISTO/A PARA DEJAR DE IMPROVISAR?
          </h2>
          <p className="text-base text-gray-300 mb-6" data-id="element-293">
            Sumate a cientos de docentes que ya tienen su año resuelto.
          </p>
          <button onClick={scrollToPurchase} className="bg-green-600 hover:bg-green-500 text-white text-lg md:text-2xl font-black py-4 px-8 rounded-full shadow-[0_0_30px_rgba(22,163,74,0.6)] hover:shadow-[0_0_50px_rgba(22,163,74,0.8)] transition-all transform hover:scale-105 uppercase" data-id="element-294">
            👉 QUIERO EMPEZAR AHORA
          </button>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="bg-black text-gray-500 py-5 px-4 text-center text-xs" data-id="element-295">
        <div className="max-w-4xl mx-auto" data-id="element-296">
          <p className="mb-2" data-id="element-297">© 2026 MEGA PACK CONTABILIDAD LISTA ™</p>
          <div className="flex justify-center gap-4" data-id="element-298">
            <span className="cursor-pointer hover:text-white" data-id="element-299">Términos</span>
            <span className="cursor-pointer hover:text-white" data-id="element-300">Privacidad</span>
            <span className="cursor-pointer hover:text-white" data-id="element-301">Soporte</span>
          </div>
        </div>
      </footer>

      {/* CheckCircle2 import fix */}
      <div className="hidden" data-id="element-302">
        <CheckCircle2 data-id="element-303" />
      </div>
    </div>;
}
function CheckCircle2(props: any) {
  return <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-304">
      <circle cx="12" cy="12" r="10" data-id="element-305" />
      <path d="m9 12 2 2 4-4" data-id="element-306" />
    </svg>;
}